const shadows = {
  sm: "0px 1px 2px rgba(0, 0, 0, 0.06)",
  base: "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
  md: "0px 4px 6px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.06)",
  lg:
    "0px -2px 11px rgba(0, 0, 0, 0.1), 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 4px 6px rgba(0, 0, 0, 0.05)",
  xl:
    "0px 0px 25px rgba(0, 0, 0, 0.1), 0px 20px 25px rgba(0, 0, 0, 0.1), 0px 0px 10px rgba(0, 0, 0, 0.04)",
  "2xl": "0px 25px 50px rgba(0, 0, 0, 0.25)",
  inner: "inset 0px 2px 4px rgba(0, 0, 0, 0.06)",
  outer:"0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)"

};

export default shadows;
